import * as fp from 'lodash/fp';

import { Observable, rx } from '@shared/rx';
import { ENgFormStatus } from '@shared/types/enums';
import {
  makeOnControlChangedOperator,
  IOnControlChangedOperator,
  IValueMakers,
} from './on-control-changed-base';

const valueMakers: IValueMakers<any> = {
  withDefaultValue: (control): Observable<any> =>
    control.statusChanges.pipe(
      rx.map(fp.isEqual(ENgFormStatus.Disabled)),
      rx.startWith(control.disabled),
    ),
  noDefaultValue: (control): Observable<any> =>
    control.statusChanges.pipe(rx.map(fp.isEqual(ENgFormStatus.Disabled))),
};

export const onControlDisabled: IOnControlChangedOperator<any> =
  makeOnControlChangedOperator(valueMakers);
